export const wallets = {
  INDEX: '/wallets',
}
